exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".md-direction-bottom-right{width:30%!important}.mrgtop-2per{margin-top:2%}.mrgtop-3per{margin-top:4%}.mrgtop-5px{margin-top:5px}.center{text-align:center}.heght-1px{height:1px}.b-form-input-container{margin:4px 0 5px!important}h3{margin:0!important}.md-button-color{background-color:#607d8d!important}.error{color:red}.md-dialog-container.HereDialog.md-theme-default{z-index:99}.md-dialog-container.HereDialog.md-theme-default .md-dialog{width:100%;height:100%}.back{margin-top:8px;height:1px}.hr-s{margin-top:10px;margin-bottom:10px;border-top:1px solid #ccc}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1d611a1a","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/view/clients/addClientDept.vue
// module id = 1419
// module chunks = 0